module.exports = "/_next/static/files/bea280a279ae8a47ea87428292a0016e.jpg";